import { getPath } from '@/router/common'
const baseUrl = {
  title: '网络运单导入订单',
  path: 'waybillImport'
}

export default [
  {
    path: getPath('ImportRecord', baseUrl),
    name: 'waybillImport_ImportRecord',
    component: () => import(/* webpackChunkName: "waybillImport_ImportRecord" */ '@/views/waybillImport/importRecord/index.vue'),
    meta: {
      title: '运单导入'
    }
  },
  {
    path: getPath('ImportRecord80548', baseUrl),
    name: 'waybillImport_ImportRecord80548',
    component: () => import(/* webpackChunkName: "waybillImport_ImportRecord80548" */ '@/views/waybillImport/importRecord80548/index.vue'),
    meta: {
      title: '装箱清单导入'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'waybillImport_Index',
    component: () => import(/* webpackChunkName: "waybillImport_Index" */ '@/views/waybillImport/index/index.vue'),
    meta: {
      title: '导入运单'
    }
  },
  {
    path: getPath('Details', baseUrl),
    name: 'waybillImport_Details',
    component: () => import(/* webpackChunkName: "waybillImport_Details" */ '@/views/waybillImport/details/index.vue'),
    meta: {
      title: '导入运单明细'
    }
  },
  {
    path: getPath('ImportRecord_Detail80548', baseUrl),
    name: 'waybillImport_ImportRecord_Detail80548',
    component: () => import(/* webpackChunkName: "waybillImport_ImportRecord_Detail80548" */ '@/views/waybillImport/importRecord_Detail80548/index.vue'),
    meta: {
      title: '导入装箱清单'
    }
  },
]
